import randomString from 'random-string';
import * as notificationActions from './notificationActions';
let timer = null;

//const
// This returns a redux-thunk action (a function).
export const notify = ({ type = 'info', text, timeout }) =>
{
	if (!timeout)
	{
		switch (type)
		{
			case 'info':
				timeout = 3000;
				break;
			case 'error':
				timeout = 3000;
				break;
			default:
				timeout = 3000;
				break;
		}
	}

	const notification =
	{
		id      : randomString({ length: 6 }).toLowerCase(),
		type    : type,
		text    : text,
		timeout : timeout
	};

    // 添加了防抖处理，过滤了一部分消息
	return (dispatch) =>
	{
		//if (timer) clearTimeout(timer);

		//timer = setTimeout(() => {
			dispatch(notificationActions.addNotification(notification));

			setTimeout(() => {
				dispatch(notificationActions.removeNotification(notification.id));
			}, timeout);
		//}, 1000);
	};

};
